import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import {Observable, Subject, Subscriber} from 'rxjs/Rx';
import { NbAuthService } from '@nebular/auth';
import { NbThemeService } from '@nebular/theme';
import { config } from '../../../config';
import { applicationApi } from '../model/applicationApi';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private baseUrl = config.serverUrl;
  constructor(private httpClient : HttpClient,
    public authService : NbAuthService,
    public themeService : NbThemeService) { }


    get(url: string): Observable<any> {
      return new Observable((observer: Subscriber<any>) => {
          let objectUrl: string = null;
          this.httpClient
              .get(url, {
                  responseType: 'blob'
              })
              .subscribe(m => {
                  objectUrl = URL.createObjectURL(m);
                  observer.next(objectUrl);
              });

          return () => {
              if (objectUrl) {
                  URL.revokeObjectURL(objectUrl);
                  objectUrl = null;
              }
          };
      });
  }

    login(email,password){
      try{
        return this.httpClient.post(`${this.baseUrl}/api/auth/login`,{"email":email,"password":password});
      }catch(error) {
        this.handleError("login from api : "+error);
      }
    }


    RegisterValues(data)
    {
      try{
          return this.httpClient.post(`${this.baseUrl}/api/auth/register`,{data : data});
      }catch(error){
        this.handleError('register errors')
      }
    }

    updateRegisterValues(data)
    {
      try{
          return this.httpClient.post(`${this.baseUrl}/api/auth/update_register`,{data : data});
      }catch(error){
        this.handleError('register errors')
      }
    }

    emailValues(data){
      try{

            return  this.httpClient.post(`${this.baseUrl}/api/auth/checkEmail`,{
              data : data

            });

      }catch(error){
        this.handleError("emailValues: "+JSON.stringify(error));
      }
    }


    ForgotPassword(email)
    {
      try{
          // console.log("passed data for registration is "+JSON.stringify(data));
          // return this.httpClient.post(`${this.baseUrl}/api/auth/register`,{data : data});
          return  this.httpClient.post(`${this.baseUrl}/api/auth/forgot-password`,{
                     data : email});
      }catch(error){
        this.handleError('register errors')
      }
    }

    resetPasswordValues(data){
      try{

            return  this.httpClient.post(`${this.baseUrl}/api/auth/resetpassword`,{
              data : data
            });
      }catch(error){
        this.handleError("resetPasswordValues: "+JSON.stringify(error));
      }
    }

    incorrect_certificateData(data){
      try{

        return  this.httpClient.post(`${this.baseUrl}/api/etranscript/incorrect_certificate`,{
          data : data
        });
      }catch(error){
        this.handleError("incorrect_certificate: "+JSON.stringify(error));
  }
    }


    getIncorrectFiles(user_id){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/etranscript/getIncorrectFiles?user_id=`+user_id);
    }catch(error) {
        this.handleError("getIncorrectFiles : "+JSON.stringify(error));
    }
  }

    Otpvalue(data){
    try{
      return this.httpClient.post(`${this.baseUrl}/api/auth/verify-otp-reg`,{
         data : data
      });
  }catch(error) {
    this.handleError("Otpvalue : "+JSON.stringify(error));
  }
  }
  UpdateNumberOTP(data){
    try{
      return this.httpClient.post(`${this.baseUrl}/api/auth/resend-otp`,{
         data : data
      });
  }catch(error) {
    this.handleError("UpdateNumberOTP : "+JSON.stringify(error));
  }
  }

  resendOTP(data){
    try{
      return this.httpClient.post(`${this.baseUrl}/api/auth/resend-otp`,{
         data : data
      });
  }catch(error) {
    this.handleError("UpdateNumberOTP : "+JSON.stringify(error));
  }
  }

  confirmPass(email,pass){
          try{
            return this.httpClient.post(`${this.baseUrl}/mobile/user/confirm_api_password`,{"email":email,"pass":pass});
          }catch(error) {
            this.handleError("confirmPass : "+error);
          }
        }

          getCaptcha(){
    try{
        return  this.httpClient.get(`${this.baseUrl}/api/auth/captcha`);

    }catch(error) {
      this.handleError("getCaptcha: "+JSON.stringify(error));
    }

  }

//created by namrata
addNewCollegebyStudent(college){
  try{
    return  this.httpClient.post(`${this.baseUrl}/api/addNewCollegebyStudent`,college);
  }catch(error){
    this.handleError('createInstitute: ' + JSON.stringify(error));
  }
}

createInstitute(universityName,email,country,contactNumber,contact_person,type,address, landmark,pincode,wesNumber,iqasno,cesno,eduperno,icasno,studyrefno,emprefno,visarefno,studyaccno,empaccno,visaaccno,otheraccno,myieeno,icesno,nasbano){
  try{
    return  this.httpClient.post(`${this.baseUrl}/api/attestation/createInstitute`,{"universityName":universityName,"email":email,"country":country,"contactNumber":contactNumber,"contact_person":contact_person,"type":type,"address":address, "landmark":landmark,"pincode":pincode,
    "wesNumber":wesNumber,"iqasno":iqasno,"cesno":cesno,"eduperno":eduperno,"icasno":icasno,"studyrefno":studyrefno,"emprefno":emprefno,"visarefno":visarefno
    ,"studyaccno":studyaccno,"empaccno":empaccno,"visaaccno":visaaccno,"otheraccno":otheraccno,"myieeno":myieeno,"icesno":icesno,"nasbano":nasbano});
  }catch(error){
    this.handleError('createInstitute: ' + JSON.stringify(error));
  }
}

suggestInstitute(){
  try{
    return  this.httpClient.get(`${this.baseUrl}/api/attestation/suggestInstitute`);
  }catch (error){
    this.handleError('suggestInstitute() : ' + JSON.stringify(error));
  }
}

suggestInstituteallDATA(universityName){
  try{
    return  this.httpClient.get(`${this.baseUrl}/api/attestation/suggestInstituteallDATA?universityName=`+universityName);
  }catch (error){
    this.handleError('suggestInstituteallDATA() : ' + JSON.stringify(error));
  }
}



updateInstituteData(id,universityName,email,country,contactNumber,contact_person,address,landmark,pincode,wesNumber,iqasno,cesno,eduperno,icasno,studyrefno,emprefno,visarefno,studyaccno,empaccno,visaaccno,otheraccno,myieeno,icesno,nasbano){
  try{
    return  this.httpClient.post(`${this.baseUrl}/api/attestation/updateInstituteData`,{"id":id,"universityName":universityName,"email":email,
    "country":country,"contactNumber":contactNumber,"contact_person":contact_person,"address":address, "landmark":landmark,
    "pincode":pincode,"wesNumber":wesNumber,"iaqsno":iqasno,"cesno":cesno,"eduperno":eduperno,"icasno" :icasno,"studyrefno":studyrefno,
    "emprefno":emprefno,"visarefno":visarefno,
    "studyaccno":studyaccno,"empaccno":empaccno,"visaaccno":visaaccno,"otheraccno":otheraccno,"mynieeno":myieeno,"icesno":icesno,"nasbano":nasbano});
  }catch(error){
    this.handleError('updateInstituteData: ' + JSON.stringify(error));
  }
}

deleteInstituteData(id){
  try{
    return  this.httpClient.post(`${this.baseUrl}/api/attestation/deleteInstituteData`,{"id":id});
  }catch(error){
    this.handleError('deleteInstituteData: ' + JSON.stringify(error));
  }
}

getInstituteData(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/attestation/getInstituteData`);
  }catch(error){
    this.handleError('getInstituteData: ' + JSON.stringify(error));
  }
}

addToCart(){
  try{
    return  this.httpClient.get(`${this.baseUrl}/api/attestation/addToCart`);
  }catch(error){
    this.handleError('addToCart: ' + JSON.stringify(error));
  }
}

getCartData(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/attestation/getCartData`);
  }catch(error){
    this.handleError('getCartData: ' + JSON.stringify(error));
  }
}

getUserData(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/getUserData`);
  }catch(error){
    this.handleError('getUserData: ' + JSON.stringify(error));
  }
}

PaymentDetails(order_id){
  try{
    return this.httpClient.post(`${this.baseUrl}/api/payment/PaymentDetails`,{"order_id":order_id});
  }catch(error) {
    this.handleError("PaymentDetails : "+error);
  }
}

OnlinePaymentChallan(transaction_id,payment_amount,payment_status,application_id,payment_date_time,user_id){
  try{
    return this.httpClient.post(`${this.baseUrl}/api/payment/OnlinePaymentChallan`,{user_id:user_id,payment_amount:payment_amount,transaction_id:transaction_id,date_time:payment_date_time,status_payment:payment_status,application_id:application_id});
  }catch(error) {
    this.handleError("OnlinePaymentChallan : "+error);
  }
}

saveFeedBack(feedBack,user_id){
  try{
    return this.httpClient.post(`${this.baseUrl}/api/attestation/kcFeedBack`,{user_id:user_id,feedBack:feedBack});
  }catch(error) {
    this.handleError("OnlinePaymentChallan : "+error);
  }
}

getFeedback(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/admin/adminDashboard/feedback`);
  }catch(error) {
      this.handleError("getFeedback : "+JSON.stringify(error));
    }
}

// downloadFiles(file_name):Observable<Blob>{
//   try{
//   let headers = new HttpHeaders();
//   headers.append('Content-Type', 'application/json');
//   return this.httpClient.get(`${this.baseUrl}/api/payment/download?file_name=`+file_name, { headers: headers, responseType: 'blob'}).map(
//       (res) => {
//           return new Blob([res], { type: 'application/pdf' });
//       });
//   }catch(error) {
//     this.handleError("unable to get Files : "+JSON.stringify(error));
//   }
// }

downloadMarksheetFiles(file_name):Observable<Blob>{
  try{
  let headers = new HttpHeaders();
  headers.append('Content-Type', 'application/json');
  return this.httpClient.get(`${this.baseUrl}/api/attestation/downloadMarkshhet?file_name=`+file_name, { headers: headers, responseType: 'blob'}).map(
      (res) => {
          return new Blob([res], { type: 'application/pdf' });
      });
  }catch(error) {
    this.handleError("unable to get Files : "+JSON.stringify(error));
  }
}

My_pplication(){
  try{
    return  this.httpClient.get(`${this.baseUrl}/api/attestation/my_applications`);
  }catch (error){
    this.handleError('get my applications Details : ' + JSON.stringify(error));
  }
}


Details(){
  try{
    return  this.httpClient.get(`${this.baseUrl}/api/cart`);
  }catch (error){
    this.handleError('get cart Details : ' + JSON.stringify(error));
  }
}

async cartRemove(id,institute_id){
  try{
      return await this.httpClient.post(`${this.baseUrl}/api/removeCartvalue`,{'id' : id,'institute_id':institute_id});
    }catch(error){
      this.handleError("cartRemove : "+JSON.stringify(error));
  }
}

emailupdate(email,updated_email){
  try{
    return  this.httpClient.post(`${this.baseUrl}/api/emailUpdate`,{"email": email,"updated_email" : updated_email});
  }catch (error){
    this.handleError('emailupdate : ' + JSON.stringify(error));
  }
}




setEducationDetails(data){
  try{
    return  this.httpClient.post(`${this.baseUrl}/api/attestation/setEducationDetails`,{data : data});
  }catch(error){
    this.handleError("setEducationDetails: "+JSON.stringify(error));
  }
}

getEducationDetails(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/attestation/getEducationDetails`);
  }catch(error) {
      this.handleError("getEducationDetails : "+JSON.stringify(error));
  }
}

getDocumentDetails(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/attestation/getDocumentDetails`);
  }catch(error) {
      this.handleError("getDocumentDetails : "+JSON.stringify(error));
  }
}

getDocumentStatus(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/attestation/getDocumentStatus`);
  }catch(error) {
      this.handleError("getDocumentStatus : "+JSON.stringify(error));
  }
}

getInstituteStatus(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/attestation/getInstituteStatus`);
  }catch(error) {
      this.handleError("getDocumentStatus : "+JSON.stringify(error));
  }
}

getApplyingEducation(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/attestation/getApplyingEducation`);
  }catch(error) {
      this.handleError("getApplyingEducation : "+JSON.stringify(error));
  }
}

checkCart(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/attestation/checkCart`);
  }catch(error) {
      this.handleError("checkCart : "+JSON.stringify(error));
  }
}

getProfileValues(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/dashboard/profileValue`,);
}catch(error) {
    this.handleError("getProfileValues : "+JSON.stringify(error));
}

}

getSendUniversityMail(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/admin/getapptrackerdetails`,{});
  }catch(error) {
    this.handleError("login from api : "+error);
  }
}

getAllSendMail(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/admin/getapplicationMailsDetails`,{});
  }catch(error) {
    this.handleError("login from api : "+error);
  }
}

updateProfileValues(data){
  try{
    return this.httpClient.post(`${this.baseUrl}/api/dashboard/updateProfile`,{
      data : data
    });
}catch(error) {
    this.handleError("updateProfileValues : "+JSON.stringify(error));
}

}

// admin-dashboard

sendOtp(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/admin/adminDashboard/get_otp`);
  }catch(error) {
      this.handleError("sendOtp : "+JSON.stringify(error));
  }
}
updateOtp(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/admin/adminDashboard/update_otp`);
  }catch(error) {
      this.handleError("updateOtp : "+JSON.stringify(error));
  }
}

getTranscriptDetails(user_id){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/admin/adminDashboard/getTranscriptDetails?user_id=${user_id}`);
  }catch(error) {
      this.handleError("getTranscriptDetails : "+JSON.stringify(error));
  }
}

downloadFilesAdmin(file_name,user_id):Observable<Blob>{
  try{
  let headers = new HttpHeaders();
  headers.append('Content-Type', 'application/json');
  return this.httpClient.get(`${this.baseUrl}/api/admin/adminDashboard/download?file_name=${file_name}&user_id=${user_id}`, { headers: headers, responseType: 'blob'}).map(
      (res) => {
          return new Blob([res], { type: 'application/pdf' });
      });
  }catch(error) {
    this.handleError("unable to get Files : "+JSON.stringify(error));
  }
}

getTotalApplications(page,id,name,email,year,mgr){
  try{
  const requestUrl = `${this.baseUrl}/api/admin/adminDashboard/total?page=${page}&id=${id}&name=${name}&email=${email}&acadYear=${year}&mgr=${mgr}`;
    return this.httpClient.get(requestUrl);
  }catch(error){
    this.handleError("getTotalApplications : "+JSON.stringify(error));
  }
  }

  getReturnApplications(){
    try{
      const requestUrl = `${this.baseUrl}/api/admin/adminDashboard/return`;
      return this.httpClient.get(requestUrl);
    }catch(error){
      this.handleError("getReturnApplications : "+JSON.stringify(error));
    }
  }

  getPendingApplications(page,id,name,email,mgr){
    try{
    const requestUrl = `${this.baseUrl}/api/admin/adminDashboard/unsigned?page=${page}&id=${id}&name=${name}&email=${email}&mgr=${mgr}`;
      return this.httpClient.get(requestUrl);
    }catch(error){
      this.handleError("getPendingApplications : "+JSON.stringify(error));
    }
  }

  getRequestedApplications(page,id,name,email,mgr){
    try{
    const requestUrl = `${this.baseUrl}/api/admin/adminDashboard/requested?page=${page}&id=${id}&name=${name}&email=${email}&mgr=${mgr}`;
      return this.httpClient.get(requestUrl);
    }catch(error){
      this.handleError("getRequestedApplications : "+JSON.stringify(error));
    }
  }

  getChangedApplications(page,id,name,email,mgr){console.log("page",page);

    try{
    const requestUrl = `${this.baseUrl}/api/admin/adminDashboard/changed?page=${page}&id=${id}&name=${name}&email=${email}&mgr=${mgr}`;
      return this.httpClient.get(requestUrl);
    }catch(error){
      this.handleError("getChangedApplications : "+JSON.stringify(error));
    }
  }

    getVerifiedApplications(){
      try{
      const requestUrl = `${this.baseUrl}/api/admin/adminDashboard/verified`;
      return this.httpClient.get(requestUrl);
    }catch(error){
      this.handleError("getVerifiedApplications : "+JSON.stringify(error));
    }
    }

    getSignedApplications(){
      try{
      const requestUrl = `${this.baseUrl}/api/admin/adminDashboard/signed`;
      return this.httpClient.get(requestUrl);
    }catch(error){
      this.handleError("getVerifiedApplications : "+JSON.stringify(error));
    }
    }


    // geting data for printedulab Tab
    getPrintEdulabApplications(){
      console.log("getPrintEdulabApplications");
      try{
      const requestUrl = `${this.baseUrl}/api/admin/adminDashboard/printedulab`;
      return this.httpClient.get(requestUrl);
      }catch(error){
        this.handleError("getPrintEdulabApplications : "+JSON.stringify(error));
      }
    }

    //updating tracker for printedulab Tab
    postTrackerPrintEdulab(appid){
      try{
        const requestUrl = `${this.baseUrl}/api/admin/trackerPrintEdulab`;
        return this.httpClient.put(requestUrl,{'appid':appid});
      }catch(error){
        this.handleError("getPrintEdulabApplications : "+JSON.stringify(error));
      }
    }


    getEmailedApplications() {
      try{
      const requestUrl = `${this.baseUrl}/api/admin/adminDashboard/emailed`;
      return this.httpClient.get(requestUrl);
    }catch(error){
      this.handleError("getVerifiedApplications : "+JSON.stringify(error));
    }
    }

    emaildoneApplications() {
      try{
      const requestUrl = `${this.baseUrl}/api/admin/adminDashboard/emailedApplication`;
      return this.httpClient.get(requestUrl);
    }catch(error){
      this.handleError("emailedApplication : "+JSON.stringify(error));
    }
    }

    courierdoneApplications() {
      try{
      const requestUrl = `${this.baseUrl}/api/admin/adminDashboard/courierdoneApplications`;
      return this.httpClient.get(requestUrl);
    }catch(error){
      this.handleError("courierdoneApplications : "+JSON.stringify(error));
    }
    }

    updateVerifiedBy(email, id){
      try{
        return this.httpClient.post(`${this.baseUrl}/api/admin/adminDashboard/pending/verifiedBy`,{"email":email,"id":id});
      }catch(error) {
        this.handleError("login from api : "+error);
      }
    }

    // sendEmail(id){
    //   try{
    //     return this.httpClient.post(`${this.baseUrl}/api/admin/adminDashboard/sendEmail`,{"id":id});
    //   }catch(error) {
    //     this.handleError("login from api : "+error);
    //   }
    // }

    getSigned_namrata_Applications(sort: string, order: string, page: number,per_page : number): Observable<applicationApi> {
      try{
      const requestUrl = `${this.baseUrl}/api/admin/adminDashboard/signed_namrata?sort=${sort}&order=${order}&page=${page + 1}&per_page=${per_page}`;
      return this.httpClient.get<applicationApi>(requestUrl);
    }catch(error){
      this.handleError("getVerifiedApplications : "+JSON.stringify(error));
    }
    }

    getEmailActivityTracker(){
      try{
        console.log('inside adminApi getEmailActivityTracker');
        return this.httpClient.get(`${this.baseUrl}/api/admin/adminDashboard/getEmailActivityTracker`);
      }catch(error) {
        this.handleError("getEmailActivityTracker : "+JSON.stringify(error));
      }
    }

    getEmailActivityTrackerMonthWise(params){
      try{
        return this.httpClient.post(`${this.baseUrl}/api/admin/adminDashboard/getEmailActivityTrackerMonthWise`,{
          yearMonth : params,
        });
      } catch(error) {
          this.handleError("getEmailActivityTrackerMonthWise : "+JSON.stringify(error));
      }
    }

    async getAllTranscriptData(userId, app_id){
      try{
        return await this.httpClient.get(`${this.baseUrl}/api/admin/adminDashboard/transcript_lock?userId=`+userId+'&app_id='+app_id).toPromise();
      }catch(error) {
        this.handleError("Error in getAllTranscriptData : "+error);
      }
    }

    updateErrataTranscript(errataTranscript){
      try{
        return this.httpClient.post(`${this.baseUrl}/api/admin/adminDashboard/updateErrataTranscript`,{"errataTranscript":errataTranscript});
      }catch(error) {
        this.handleError("login from api : "+error);
      }
    }

downloadTranscript(file):Observable<Blob>{

  console.log("this.baseUrl=====>"+this.baseUrl)
  try {
    let headers = new HttpHeaders();
    headers.append('Content-Type','application/json');
      return this.httpClient.get(`${this.baseUrl}/api/admin/adminDashboard/downloadTranscript?file=${file}`, { headers: headers, responseType: 'blob'}).map(
        (res) => {
          return new Blob([res], { type: 'application/pdf' });
        });

  }
   catch (error) {
    this.handleError("unable to get the Files :"+JSON.stringify(error))
  }
  }


        //////////CREATED BY PRIYANKA
        getStatuswithid(Appc_id){
          try{
                return  this.httpClient.post(`${this.baseUrl}/api/dashboard/appTrackerwithid`,{"app_id": Appc_id});
           }catch (error){
            this.handleError('getStatus: ' + JSON.stringify(error));
          }

         }

         getPurposewithid(User_id){

          try{
                return  this.httpClient.post(`${this.baseUrl}/api/dashboard/purposeTrackerwithid`,{"user_id": User_id});
           }catch (error){
            this.handleError('getStatus: ' + JSON.stringify(error));
          }

         }

         getStatus(){
          try{
                return  this.httpClient.get(`${this.baseUrl}/api/dashboard/appTracker`);
           }catch (error){
            this.handleError('getStatus: ' + JSON.stringify(error));
          }

         }

        getApplicationdetails(): any {
          try{
            return this.httpClient.get(`${this.baseUrl}/api/dashboard/getApp_details`);
          }catch(error){
            this.handleError("get application details: "+error);
          }
        }

        getpreAppldetails(): any {
          try{
            return this.httpClient.get(`${this.baseUrl}/api/dashboard/getpreAppldetails`);
          }catch(error){
            this.handleError("get application details: "+error);
          }
        }

        getErrataUpdate():any{
          try{
            return this.httpClient.get(`${this.baseUrl}/api/dashboard/getErrataUpdate`);
          }catch(error){
            this.handleError("get application details: "+error);
          }
        }



language(language:any,userId:any){
  try{
    return  this.httpClient.post(`${this.baseUrl}/api/attestation/language`,{"language":language,"userId":userId});
  }catch(error){
    this.handleError('createInstitute: ' + JSON.stringify(error));
  }
}


// signpdf(appl_id: any,type : any) {
//   try{
//     console.log('inside signpdf for application id'+appl_id);
//     return this.httpClient.post(`${this.baseUrl}/api/signpdf/signpdf`,{"appl_id":appl_id,"type":type})
//   }catch(error) {
//     this.handleError("getEmailActivityTracker : "+JSON.stringify(error));
//   }
// }

signpdf(appl_id: any,type : any, data_Values :any) {
  try{
    console.log('inside signpdf for application id'+appl_id);
    return this.httpClient.post(`${this.baseUrl}/api/signpdf/signpdf`,{"appl_id":appl_id,"type":type,"data_Values":data_Values})
  }catch(error) {
    this.handleError("getEmailActivityTracker : "+JSON.stringify(error));
  }
}

generateCertificate(appl_id: any, user_id:any, email :any, viewFrom :any) {
  try{
    console.log('inside generateCertificate for application id'+appl_id);
    return this.httpClient.post(`${this.baseUrl}/api/signpdf/migration_certificate`,{"appl_id":appl_id,"user_id":user_id,"email_admin":email,"viewForm":viewFrom})
  }catch(error) {
    this.handleError("getEmailActivityTracker : "+JSON.stringify(error));
  }
}

generatePrintCertificate(appl_id: any, user_id:any, data_Values :any ,email :any) {
  try{
    console.log('inside generateCertificate for application id'+appl_id);
    return this.httpClient.post(`${this.baseUrl}/api/signpdf/migration_certificate_print`,{"appl_id":appl_id,"data_Values":data_Values,"user_id":user_id, "email_admin":email})
  }catch(error) {
    this.handleError("getEmailActivityTracker : "+JSON.stringify(error));
  }
}



         /**
   * Adds notifications to the Database
   * @author Rafique Shaikh
   */

  socketmessage = new Subject();
  socketNotificationNo = new Subject();
  private notification_no : any;
private messages = [];

  sendNotifications(appId,type){
    try {
      return this.httpClient.post(`${this.baseUrl}/api/admin/adminDashboard/sendNotification`, {"id":appId,"type":type});
    } catch (error) {
      this.handleError("sendNotifications: "+JSON.stringify(error));
    }
  }

  receiveNotifications(userId){
   return this.httpClient.post(`${this.baseUrl}/api/admin/adminDashboard/receiveNotification`, {"id":userId}).subscribe(notifications=>{
      this.messages = notifications['data'];
      this.notification_no = notifications['notification_no'];
      if(notifications['data'].length == 0){
        this.socketNotificationNo.next('');
        this.socketmessage.next('');
      }else if(notifications['data'].length > 0){
        this.socketNotificationNo.next(this.notification_no);
        this.socketmessage.next(this.messages);
      }
    },error => {
      this.handleError("receiveNotifications: "+JSON.stringify(error));
      });
  }

  reloadnotification(userId){
   try{
      return this.httpClient.post(`${this.baseUrl}/api/admin/adminDashboard/receiveNotification`,{"id":userId});
    }catch(error) {
      this.handleError("notification : "+error);
    }
  }

  makeReadNotification(userId){
    try{
      return this.httpClient.post(`${this.baseUrl}/api/admin/adminDashboard/makeReadNotification`,{"id":userId});
    }catch(error) {
      this.handleError("makeReadNotification : "+error);
    }
  }

  checkWesStatus(user_id){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/wes/checkStats?userId=`+user_id);
     }catch(error) {
       this.handleError("checkStats: "+JSON.stringify(error));
     }
  }


  deleteNotification(userId,noti_id){
    try{
      return this.httpClient.post(`${this.baseUrl}/api/admin/adminDashboard/deleteNotification`,{"id":userId,"noti_id":noti_id});
    }catch(error) {
      this.handleError("deleteNotification : "+error);
    }
  }

  getTheme(){
    try{
      return  this.httpClient.get(`${this.baseUrl}/api/dashboard/getTheme`);
    }catch(error) {
      this.handleError("getTheme : "+error);
    }
  }

 /**
   * Adds notifications to the Database for errata
   * @author Priyanka khandagale
   */
  sendmessage(msg_from_admin_data){
    try{
      return this.httpClient.post(`${this.baseUrl}/api/admin/adminDashboard/trans_sendmessage`,{"msg":msg_from_admin_data});
    }catch(error) {
      this.handleError("ERROR sendmessage : "+error);
    }
  }

  checkapplications(){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/attestation/checkapplications`);
    }catch(error) {
      this.handleError("checkapplications : "+error);
    }
  }

  getAllPayments(){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/payment/getAllPayments`);
    }catch(error){
      this.handleError('getAllPayments: ' + JSON.stringify(error));
    }
  }

  getApplWisePayments(appl_id){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/payment/getApplWisePayments?appl_id=${appl_id}`);
    }catch(error){
      this.handleError('getAllPayments: ' + JSON.stringify(error));
    }
  }

  downloadPaymentExcel(pdf):Observable<Blob>{
    try{
      let headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      return this.httpClient.get(`${this.baseUrl}/api/payment/downloadExcel?pdf=`+pdf, { headers: headers, responseType: 'blob'}).map(
        (res) => {
            return new Blob([res], { type: 'application/pdf' });
        });
    }catch(error) {
      this.handleError("downloadPaymentExcel unable to get Files : "+JSON.stringify(error));
    }
  }


  splitExcel(){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/payment/splitExcel`);
    }catch(error) {
      this.handleError("splitExcel : "+JSON.stringify(error));
    }
  }

  downloadReceipt(id):Observable<Blob>{
    try{
      let headers = new HttpHeaders();
      headers.append('Content-Type','application/json');
        return this.httpClient.get(`${this.baseUrl}/api/attestation/downloadPaymentReceipt?appl_id=`+id, { headers: headers, responseType: 'blob'}).map(
          (res) => {
            return new Blob([res], { type: 'application/pdf' });
          });
     }catch(error){
      this.handleError("Error downloadpaymentReceipt: "+JSON.stringify(error));
    }
  }

  getSignedPdfDetails(appl_id,user_id) {
    try{
      return this.httpClient.get(`${this.baseUrl}/api/admin/adminDashboard/getSignedPdfDetails?user_id=${user_id}&appl_id=${appl_id}`);
    }catch(error) {
        this.handleError("getSignedPdfDetails : "+JSON.stringify(error));
    }
  }

  downloadForm(appl_id,user_id , type) {
    try{
      return  this.httpClient.post(`${this.baseUrl}/api/signpdf/application_form`,{"appl_id" : appl_id, "user_id" : user_id, "type" : type});
    }catch(error) {
        this.handleError("getSignedPdfDetails : "+JSON.stringify(error));
    }
  }

  download_applicationForm(file_name):Observable<Blob>{
    try{
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.httpClient.get(`${this.baseUrl}/api/signpdf/download_applicationForm?file_name=`+file_name, { headers: headers, responseType: 'blob'}).map(
        (res) => {
            return new Blob([res], { type: 'application/pdf' });
        });
    }catch(error) {
      this.handleError("unable to get Files : "+JSON.stringify(error));
    }
  }


  downloadFilesAdmin_signedpdf(file_name):Observable<Blob>{
    try{
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.httpClient.get(`${this.baseUrl}/api/admin/adminDashboard/downloadSignedpdf?file_name=${file_name}`, { headers: headers, responseType: 'blob'}).map(
        (res) => {
            return new Blob([res], { type: 'application/pdf' });
        });
    }catch(error) {
      this.handleError("unable to get Files : "+JSON.stringify(error));
    }
  }

  checkTransStatus(user_id) {
    try{
      return this.httpClient.get(`${this.baseUrl}/api/admin/adminDashboard/getAppTransStatus?user_id=${user_id}`)
    }catch(error){
      this.handleError("checkTransStatus: "+JSON.stringify(error));
    }
  }

  //NEW
getBoard(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/attestation/getBoard`);
  }catch(error) {
      this.handleError("getBoard : "+JSON.stringify(error));
  }
}

saveBoard(board_id,user_id){
  try{
    return  this.httpClient.post(`${this.baseUrl}/api/attestation/saveBoard`,{"board_id" : board_id, "user_id" : user_id});
  }catch(error) {
      this.handleError("saveBoard : "+JSON.stringify(error));
  }
}

getUserWiseBoard(){
  try{
    return  this.httpClient.get(`${this.baseUrl}/api/attestation/getUserWiseBoard`);
  }catch(error) {
      this.handleError("getUserWiseBoard : "+JSON.stringify(error));
  }
}

//Get IP Adress using http://freegeoip.net/json/?callback
getIpAddress() {
  return this.httpClient
  .get('https://ipapi.co/json/')
    //.get('http://ip-api.com/json')
    .map(response => response || {})
    .catch(this.handleError1);
}

getCollegeList(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/getCollegeList`);
  }catch(error){
    this.handleError('getCollegeList: ' + JSON.stringify(error));
  }
}

getFacultyList(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/getFacultyList`);
  }catch(error){
    this.handleError('getFacultyList: ' + JSON.stringify(error));
  }
}

getTranscript_name(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/dashboard/getTranscript_name`,);
  }catch(error) {
      this.handleError("getTranscript_name : "+JSON.stringify(error));
  }
}

getcheckstepper(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/dashboard/checkStepper`,);
  }catch(error) {
      this.handleError("getTranscript_name : "+JSON.stringify(error));
  }
}


getallstudents(page,name,email){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/admin/adminDashboard/students?page=${page}&name=${name}&email=${email}`);
  }catch(error) {
      this.handleError("getallstudents : "+JSON.stringify(error));
    }
}

getCountryWiseApplication(year,country_name,applying_for){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/admin/adminDashboard/getCountryWiseApplication?year=`+year+'&country_name='+country_name+'&applying_for='+applying_for);
  }catch(error) {
      this.handleError("getallstudents : "+JSON.stringify(error));
    }
}

status(status,userId){
  try{
    return this.httpClient.put(`${this.baseUrl}/api/admin/adminDashboard/status`,{"status":status,"userId": userId});
  }catch(error) {
    this.handleError("status : "+JSON.stringify(error));
  }
}

getApplWisePaymentsAdmin(appl_id,user_id){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/admin/adminDashboard/getApplWisePayments?appl_id=`+appl_id+`&id=`+user_id);
  }catch(error){
    this.handleError('getAllPayments: ' + JSON.stringify(error));
  }
}

downloadReceiptAdmin(id,user_id):Observable<Blob>{
  try{
    let headers = new HttpHeaders();
    headers.append('Content-Type','application/json');
      return this.httpClient.get(`${this.baseUrl}/api/admin/adminDashboard/downloadPaymentReceipt?appl_id=`+id+`&user_id=`+user_id, { headers: headers, responseType: 'blob'}).map(
        (res) => {
          return new Blob([res], { type: 'application/pdf' });
        });
   }catch(error){
    this.handleError("Error downloadpaymentReceipt: "+JSON.stringify(error));
  }
}

view_Application(id){
  try{
    return  this.httpClient.get(`${this.baseUrl}/api/admin/adminDashboard/my_applications?id=`+id);
  }catch (error){
    this.handleError('get my applications Details : ' + JSON.stringify(error));
  }
}

getPaymentDetails(tab_type){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/payment/getPaymentDetails?tab_type=`+tab_type);
  }catch(error) {
    this.handleError("getPaymentDetails : "+JSON.stringify(error));
  }
}

proceedSplit(order_id,edu_share,uni_share,ccavenue_share,reference_no){
  try{
    return this.httpClient.post(`${this.baseUrl}/api/payment/proceedSplit`,{"order_id":order_id,"edu_share":edu_share,"uni_share":uni_share,"ccavenue_share":ccavenue_share,"reference_no":reference_no});
  }catch(error) {
    this.handleError("proceed2ndSplit : "+JSON.stringify(error));
  }
}

proceedRefund(order_no,order_id,edu_refund,uni_refund,cc_refund,reference_no){
  try{
    return this.httpClient.post(`${this.baseUrl}/api/payment/proceedRefund`,{"order_no":order_no,"order_id":order_id,"edu_refund":edu_refund,"uni_refund":uni_refund,"cc_refund":cc_refund,"reference_no":reference_no});
  }catch(error) {
    this.handleError("proceedRefund : "+JSON.stringify(error));
  }
}

feedBack(satisfy, recommend, staff, experience, exp_prob, suggestion , user_id){
  try{
    return this.httpClient.post(`${this.baseUrl}/api/attestation/feedBack`,{"satisfy":satisfy, "recommend":recommend, "staff":staff, "experience":experience, "exp_prob":exp_prob, "suggestion":suggestion , "user_id" : user_id});
  }catch(error) {
    this.handleError("feedBack : "+error);
  }
}

getactivity(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/admin/adminDashboard/getactivity`);
  }catch(error) {
      this.handleError("getallstudents : "+JSON.stringify(error));
    }
}

activitytracker(page,name,email,type_data){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/admin/adminDashboard/activitytracker?page=${page}&name=${name}&email=${email}&type_data=${type_data}`);
  }catch(error) {
    this.handleError("activitytracker : "+JSON.stringify(error));
  }
}

downloadExcel(type){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/admin/adminDashboard/downloadExcel?type=`+type)
  }catch(error){
    this.handleError(" downloadExcel : "+JSON.stringify(error))
  }
}

downloadmerge(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/admin/adminDashboard/downloadmerge`)
  }catch(error){
    this.handleError("downloadmerge : "+JSON.stringify(error))
  }
}

downloadFilesExcel(file_path):Observable<Blob>{
  try{
  let headers = new HttpHeaders();
  headers.append('Content-Type', 'application/json');
  return this.httpClient.get(`${this.baseUrl}/api/admin/adminDashboard/downloadfile?file_path=`+file_path, { headers: headers, responseType: 'blob'}).map(
      (res) => {
          return new Blob([res], { type: 'application/pdf' });
      });
  }catch(error) {
    this.handleError("unable to get Files : "+JSON.stringify(error));
  }
}

downloadmergefile(file_path):Observable<Blob>{
  try{
  let headers = new HttpHeaders();
  headers.append('Content-Type', 'application/json');
  return this.httpClient.get(`${this.baseUrl}/api/admin/adminDashboard/downloadmergefile?file_path=`+file_path, { headers: headers, responseType: 'blob'}).map(
      (res) => {
          return new Blob([res], { type: 'merge/pdf' });
      });
  }catch(error) {
    this.handleError("unable to get Files : "+JSON.stringify(error));
  }
}

getMenuRole(userID){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/admin/role_management/getMenuRole?userID=`+userID);
  }catch(error){
    this.handleError(" getMenuRole : "+JSON.stringify(error));
  }
}

getallstudentfeedback(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/admin/student_feeback`);
  }catch(error) {
    this.handleError("getallstudentfeedback : "+JSON.stringify(error));
  }
}

getallsubadmin(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/admin/role_management/main`);
  }catch(error) {
      this.handleError("getallsubadmin : "+JSON.stringify(error));
    }
}

addupdateRole(roles,user_id){
  try{
    return this.httpClient.post(`${this.baseUrl}/api/admin/role_management/setUpdateRole`,{"roles":roles,"user_id":user_id});
  }catch(error) {
      this.handleError("addupdateRole : "+JSON.stringify(error));
    }
}

getRolesData(userId){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/admin/role_management/getRolesData?userId=`+userId);
  }catch(error) {
      this.handleError("getRolesData : "+JSON.stringify(error));
    }
}

getSubAdminData(userId){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/admin/role_management/getSubAdminData?userId=`+userId);
  }catch(error) {
    this.handleError("getSubAdminData : "+JSON.stringify(error));
  }
}

addUpdatesubAdmin(userId, subAdminData){
  try{
    return this.httpClient.post(`${this.baseUrl}/api/admin/role_management/addUpdatesubAdmin`,{"userId" : userId, "subAdminData" : subAdminData});
  }catch(error) {
    this.handleError("addUpdatesubAdmin : "+JSON.stringify(error));
  }
}

changeSubAdminStatus(userId){
  try{
    return this.httpClient.post(`${this.baseUrl}/api/admin/role_management/changeSubAdminStatus`,{"userId" : userId});
  }catch(error) {
    this.handleError("changeSubAdminStatus : "+JSON.stringify(error));
  }
}


getPassword(app_id, docID , location,email,fileName){
  try{
    return this.httpClient.post(`${this.baseUrl}/api/admin/getclickDetails`,{"app_id" :app_id , "docID": docID , "location" : location, "email": email, "fileName" : fileName});
  }catch(error) {
    this.handleError("getRolesData : "+JSON.stringify(error));
  }
}

getapplWiseTracker(Appc_id,user_id,email){
  try{
    return this.httpClient.post(`${this.baseUrl}/api/admin/getapplWiseTracker`,{"app_id" :Appc_id , "user_id" : user_id, "email": email});
  }catch(error) {
    this.handleError("getRolesData : "+JSON.stringify(error));
  }
}

downloadStructureFile(filePath,app_id):Observable<Blob>{
  try{
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
  return this.httpClient.get(`${this.baseUrl}/api/auth/downloadStructureFile?file_name=`+filePath+`&app_id=`+app_id, {headers: headers, responseType: 'blob'}).map(
      (res) => {
          return new Blob([res], { type: 'application/pdf' });
      });
  }catch(error) {
    this.handleError("unable to get Files : "+JSON.stringify(error));
  }
}


addUserDegree(degree){ ///api/attestation/createInstitute
  try{
    return this.httpClient.post(`${this.baseUrl}/api/attestation/addUserDegree`,{"degree" :degree});
  }catch(error) {
    this.handleError("addUserDegree: "+JSON.stringify(error));
  }
}

getUploadUserMarklist(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/attestation/getUploadUserMarklist`);
  }catch(error) {
    this.handleError("getUploadUserMarklist: "+JSON.stringify(error));
  }
}

viewFileYearWise(year,pattern,education){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/attestation/viewFileYearWise?year=`+year+`&pattern=`+pattern+'&education='+education);
  }catch(error) {
    this.handleError("viewFileYearWise: "+JSON.stringify(error));
  }
}

getMarklistLetter(id){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/attestation/getMarklistLetter?id=`+id)
  }catch(error) {
    this.handleError("getMarklistLetter  : "+JSON.stringify(error));
  }
}


getUserEducation(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/attestation/getUserEducation`);
  }catch(error) {
    this.handleError("getUserEducation: "+JSON.stringify(error));
  }
}

deleteTranscript(userData){
  try{
    return this.httpClient.post(`${this.baseUrl}/api/dashboard/deleteTranscripts`,{'data':userData});
  }catch(error) {
    this.handleError("getUploadTranscript: "+JSON.stringify(error));
  }
}


deleteUploadFile(id){
  try{
      return this.httpClient.delete(`${this.baseUrl}/api/attestation/deleteUploadFile?id=`+id);

  }catch(error) {
    this.handleError("deleteUploadFile: "+JSON.stringify(error));
  }
}

async getPurposeDetails(userId){
  try{
    return await this.httpClient.get(`${this.baseUrl}/api/admin/adminDashboard/getPurposeDetails?userId=`+userId).toPromise();
  }catch(error) {
    this.handleError("Error in getPurposeDetails : "+error);
  }
}

getUploadedTranscript(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/dashboard/getUploadedTranscripts`,);
  }catch(error) {
      this.handleError("getUploadedTranscripts : "+JSON.stringify(error));
  }
}
getuserEducationDetails(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/attestation/getuserEducationDetails`);
  }catch(error) {
    this.handleError("getuserEducationDetails: "+JSON.stringify(error));
  }
}

getUserMasterDetails(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/attestation/getUserMasterDetails`);
  }catch(error) {
    this.handleError("getUserMasterDetails: "+JSON.stringify(error));
  }
}
getUserPhdDetails(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/attestation/getUserPhdDetails`);
  }catch(error) {
    this.handleError("getUserPhdDetails: "+JSON.stringify(error));
  }
}
getUploadedMarklist(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/attestation/getUploadedMarklist`,);
  }catch(error) {
      this.handleError("getUploadedMarklist : "+JSON.stringify(error));
  }
}

getUploadedMasterMarklist(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/attestation/getUploadedMasterMarklist`,);
  }catch(error) {
      this.handleError("getUploadedMasterMarklist : "+JSON.stringify(error));
  }
}
getUploadedPhdMarklist(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/attestation/getUploadedPhdMarklist`,);
  }catch(error) {
      this.handleError("getUploadedPhdMarklist : "+JSON.stringify(error));
  }
}
deleteMarklist(userData){
  try{
    return this.httpClient.post(`${this.baseUrl}/api/attestation/deleteMarklist`,{'data':userData});
  }catch(error) {
    this.handleError("getUploadUserMarklist: "+JSON.stringify(error));
  }
}

deleteErrataMarklist(userData){
  try{
    return this.httpClient.post(`${this.baseUrl}/api/attestation/deleteErrataMarklist`,{'data':userData});
  }catch(error) {
    this.handleError("deleteErrataMarklist: "+JSON.stringify(error));
  }
}

deleteErrataTranscript(userData){
  try{
    return this.httpClient.post(`${this.baseUrl}/api/dashboard/deleteErrataTranscript`,{'data':userData});
  }catch(error) {
    this.handleError("deleteErrataTranscript: "+JSON.stringify(error));
  }
}


deleteErrataCurriculum(userData){
  try{
    return this.httpClient.post(`${this.baseUrl}/api/attestation/deleteErrataCurriculum`,{'data':userData});
  }catch(error) {
    this.handleError("deleteErrataCurriculum: "+JSON.stringify(error));
  }
}



changeCollegeWithDeleteMarklist(year,pattern,education){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/attestation/changeCollegeWithDeleteMarklist?year=`+year+`&pattern=`+pattern +`&education=`+education);
  }catch(error) {
    this.handleError("getUserEducation: "+JSON.stringify(error));
  }
}

checksignedpdf(appl_id,user_id) {
  try{
    return this.httpClient.get(`${this.baseUrl}/api/admin/adminDashboard/checksignedpdf?user_id=${user_id}&appl_id=${appl_id}`);
  }catch(error) {
      this.handleError("getchecksignedpdf : "+JSON.stringify(error));
  }
}

mergedpdf(appl_id) {
  try{
   return this.httpClient.post(`${this.baseUrl}/api/signpdf/mergedpdf`,{"appl_id":appl_id})
  }catch(error) {
    this.handleError("getEmailActivityTracker : "+JSON.stringify(error));
  }
}



sendemail(appl_id) {
  try{
   return this.httpClient.post(`${this.baseUrl}/api/signpdf/email_signpdf`,{"appl_id":appl_id})
  }catch(error) {
    this.handleError("getEmailActivityTracker : "+JSON.stringify(error));
  }
}

uploadWes(user_id,dateOfWes){
  try{
    return this.httpClient.post(`${this.baseUrl}/api/wes/uploadWes`,{"user_id":user_id,"date":dateOfWes})
   }catch(error) {
     this.handleError("uploadWes : "+JSON.stringify(error));
   }
}


private handleError1(error: HttpErrorResponse):
  Observable<any> {
    //Log error in the browser console
    console.error('observable error: ', error);

    return Observable.throw(error);
  }

//NEW END

  private handleError(error){
    console.error(error);
  }

  updateLoginCount(user_id){
    try{
      return this.httpClient.put(`${this.baseUrl}/api/attestation/updateLoginCount`,{"user_id": user_id});
    }catch(error) {
      this.handleError("updateLoginCount : "+JSON.stringify(error));
    }
  }

  refreshCollegeEmailStatus(user_id,app_id){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/admin/collegeEmailStatusUpdate?user_id=${user_id}&app_id=${app_id}`);
    }catch(error) {
        this.handleError("refreshCollegeEmailStatus : "+JSON.stringify(error));
    }
  }

  sendEmailToCollege(collegeId,user_id){
    try{
      return this.httpClient.post(`${this.baseUrl}/api/admin/sendEmailToCollege`,{"collegeId":collegeId,"user_id":user_id});
    }catch(error) {
      this.handleError("deleteNotification : "+error);
    }
  }

  getInstructionalEducation(){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/attestation/getInstructionalDetails`);
    }catch(error) {
      this.handleError("getUserEducation: "+JSON.stringify(error));
    }
  }

  addUserInstructionalDetails(instructionalDetails:boolean){ ///api/attestation/createInstitute
    try{
      return this.httpClient.post(`${this.baseUrl}/api/attestation/instructionalDetails`,{"instructionalDetails" :instructionalDetails});
    }catch(error) {
      this.handleError("addUserInstutional: "+JSON.stringify(error));
    }
  }

  addUserCurriculumDetails(curriculumDetails:boolean){ ///api/attestation/createInstitute
    try{
      return this.httpClient.post(`${this.baseUrl}/api/attestation/curriculumDetails`,{"curriculumDetails" :curriculumDetails});
    }catch(error) {
      this.handleError("addUserInstutional: "+JSON.stringify(error));
    }
  }

  addUserEducationalDetails(educationalDetails:boolean){ ///api/attestation/createInstitute
    try{
      return this.httpClient.post(`${this.baseUrl}/api/attestation/educationalDetails`,{"educationalDetails" :educationalDetails});
    }catch(error) {
      this.handleError("addUserInstutional: "+JSON.stringify(error));
    }
  }



  addinstructionalDetails(object:Object){
    try{
      return this.httpClient.post(`${this.baseUrl}/api/attestation/instructionalUserDetails`,object);
    }catch(error) {
      this.handleError("addUserInstutional: "+JSON.stringify(error));
    }
  }



  downloadCurriculum(file_name):Observable<Blob>{
    try{
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.httpClient.get(`${this.baseUrl}/api/dashboard/downloadCurriculum?file_name=`+file_name, { headers: headers, responseType: 'blob'}).map(
        (res) => {
            return new Blob([res], { type: 'application/pdf' });
        });
    }catch(error) {
      this.handleError("unable to get Files : "+JSON.stringify(error));
    }
  }

  downloadMarklist(file_name):Observable<Blob>{
    try{
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.httpClient.get(`${this.baseUrl}/api/attestation/downloadMarklist?file_name=`+file_name, { headers: headers, responseType: 'blob'}).map(
        (res) => {
            return new Blob([res], { type: 'application/pdf' });
        });
    }catch(error) {
      this.handleError("unable to get Files : "+JSON.stringify(error));
    }
  }


  deleteUploadpdf(id){
    try{
        return this.httpClient.delete(`${this.baseUrl}/api/attestation/deleteUploadpdf?id=`+id);

    }catch(error) {
      this.handleError("deleteUploadpdf: "+JSON.stringify(error));
    }
  }

  getAdminInstructionalEducation(userId){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/attestation/getAdminInstructionalDetails?userId=`+userId);
    }catch(error) {
      this.handleError("getUserEducation: "+JSON.stringify(error));
    }
  }

  // wesDate(date,user_id){
  //   try{
  //     return this.httpClient.post(`${this.baseUrl}/api/wes/wesDate`,{"date":date,"user_id":user_id})
  //    }catch(error) {
  //      this.handleError("wesDate : "+JSON.stringify(error));
  //    }
  // }


  wesStudent(){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/wes/getAllWes`)
     }catch(error) {
       this.handleError("wesStudent: "+JSON.stringify(error));
     }
  }




  getuploadedCurriculum(){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/dashboard/getuploadedCurriculum`,);
    }catch(error) {
        this.handleError("getuploadedCurriculum : "+JSON.stringify(error));
    }
  }


  viewPdf(appId,userId){
    try{
    const requestUrl = `${this.baseUrl}/api/wes/viewPdf?app_id=${appId}&userid=${userId}`;
    return this.httpClient.get(requestUrl);
  }catch(error){
    this.handleError("getWesApplications : "+JSON.stringify(error));
  }
  }

  generateInstrucionalLetter(app_id){
    try{
      return this.httpClient.post(`${this.baseUrl}/api/admin/generateInstrucionalLetter`,{"app_id" : app_id});
    }catch(error) {
      this.handleError("generateInstrucionalLetter: "+JSON.stringify(error));
    }
  }

  getMarkListDetails(degreeName){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/attestation/getMarkListDetails?degreeName=`+degreeName);
    }catch(error) {
      this.handleError("getUserEducation: "+JSON.stringify(error));
    }
  }
  saveMarkListDetails(data){
    try{
      return this.httpClient.post(`${this.baseUrl}/api/attestation/saveMarkListDetails`,{"data":data})
     }catch(error) {
       this.handleError("getUserEducation : "+JSON.stringify(error));
     }
  }

  deleteDetails(id){
    try{
      return this.httpClient.post(`${this.baseUrl}/api/attestation/deleteDetails`,{'id':id});
    }catch(error) {
      this.handleError("getUploadUserMarklist: "+JSON.stringify(error));
    }
  }


  getCollegeData(){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/admin/collegeManagement/getCollegeData`);
    }catch(error) {
        this.handleError("getCollegeData : "+JSON.stringify(error));
      }
  }
  getCousreData(){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/admin/getCousreData`);
    }catch(error) {
        this.handleError("getCousreData : "+JSON.stringify(error));
      }
  }

  getCollegeCourseData(college_name){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/admin/collegeManagement/getCollegeCourseData?college_name=`+college_name);
    }catch(error) {
      this.handleError("getCollegeCourseData : "+JSON.stringify(error));
    }
  }


 deleteCollegecourse(id){
  console.log('sdfblfb;dea;lgs; v l; l;sf');

    try{
        return this.httpClient.delete(`${this.baseUrl}/api/admin/collegeManagement/deleteCollegecourse?id=`+id);

    }catch(error) {
      this.handleError("deleteCollegecourse: "+JSON.stringify(error));
    }
  }

  rejectApplication(user_id,app_id,email_admin){
    try{
      return this.httpClient.post(`${this.baseUrl}/api/admin/adminDashboard/rejectApplication`,{"user_id":user_id,"app_id":app_id,"email_admin":email_admin});
        //return this.httpClient.get(requestUrl);
      }catch(error){
        this.handleError("rejectApplication : "+JSON.stringify(error));
      }
  }

  getRejectedApplication(){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/admin/adminDashboard/getRejectedApplication`);
        //return this.httpClient.get(requestUrl);
      }catch(error){
        this.handleError("getRejectedApplication : "+JSON.stringify(error));
      }
  }

  addOrUpdateCollegeData(data){
    try{
      return this.httpClient.post(`${this.baseUrl}/api/admin/collegeManagement/addOrUpdateCollegeData`,{"collegeData":data})
     }catch(error) {
       this.handleError("addOrUpdateCollegeData : "+JSON.stringify(error));
     }
  }

  addOrUpdateCourseData(data){
    try{
      return this.httpClient.post(`${this.baseUrl}/api/admin/collegeManagement/addOrUpdateCourseData`,{"courseData":data})
     }catch(error) {
       this.handleError("addOrUpdateCourseData : "+JSON.stringify(error));
     }
  }

  removeCollege(college_id){
    try{
      return this.httpClient.post(`${this.baseUrl}/api/admin/collegeManagement/removeCollege`,{"college_id":college_id})
     }catch(error) {
       this.handleError("addOrUpdateCollegeData : "+JSON.stringify(error));
     }
  }

  deleteEducationDetail(id,user_id,app_id,email_admin){

    try{
      return this.httpClient.delete(`${this.baseUrl}/api/admin/adminDashboard/deleteEducationDetail?id=`+id+`&user_id=`+user_id+`&app_id=`+app_id+`&email_admin=`+email_admin)

    }catch(error)
{

this.handleError("deleteEducationDetail:" +JSON.stringify(error))
}
 }

  refreshPurposeEmailStatus(){
    try{
      return  this.httpClient.get(`${this.baseUrl}/api/cron/updateEmailStatus`);
    }catch(error){
      this.handleError('refreshPurposeEmailStatus: ' + JSON.stringify(error));
    }
  }

  getErrataDocs(){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/admin/adminDashboard/errataDocuments`);
    }catch(error) {
        this.handleError("sendOtp : "+JSON.stringify(error));
    }
  }

  lockDocument(doc_id,user_id,set,app_id){
    try{
      return this.httpClient.post(`${this.baseUrl}/api/admin/adminDashboard/lockDocuments`,{doc_name:name,doc_id:doc_id,user_id:user_id,set:set, app_id : app_id});
    }catch(error) {
        this.handleError("sendOtp : "+JSON.stringify(error));
    }
  }

  downloadDocument(file_name):Observable<Blob>{
    try{
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.httpClient.get(`${this.baseUrl}/api/admin/downloadDocument?file_name=`+file_name, { headers: headers, responseType: 'blob'}).map(
        (res) => {
            return new Blob([res], { type: 'application/pdf' });
        });
    }catch(error) {
      this.handleError("unable to get Files : "+JSON.stringify(error));
    }
  }

  preview(){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/attestation/preview`);
    }catch(error) {
        this.handleError("sendOtp : "+JSON.stringify(error));
    }
  }

  sendToken(token){
    //`${this.baseUrl}/api/admin/collegeManagement/removeCollege`,{"college_id":college_id}
    return this.httpClient.post<any>(`${this.baseUrl}/api/etranscript`, {"recaptcha": token})
  }

  addFirstFormData(item: any): Observable<any> {
    try{
      return  this.httpClient.post(`${this.baseUrl}/api/etranscript/addFirstFormData`,item);
    }catch (error){
      this.handleError('addFirstFormData : ' + JSON.stringify(error));
    }
  }

  updateFirstformData(item:any,user_id,newAddress:any):Observable<any>{
    try{
      return  this.httpClient.post(`${this.baseUrl}/api/etranscript/updateFirstformData`,{'item':item,'user_id':user_id,'newAddress':newAddress});
    }catch (error){
      this.handleError('updateFirstformData : ' + JSON.stringify(error));
    }
  }


  checkPrn(prnno){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/etranscript/checkPrn?prnno=`+prnno);
    }catch(error) {
        this.handleError("sendOtp : "+JSON.stringify(error));
    }
  }

  
  getApplicantData(user_id) {
    try{
      return  this.httpClient.post(`${this.baseUrl}/api/etranscript/getApplicantData`,{'user_id':user_id});
    }catch (error){
      this.handleError('getApplicantData : ' + JSON.stringify(error));
    }
  }

  mailToDoneStudent(id,email,user_id,date) {
    try{
      return  this.httpClient.post(`${this.baseUrl}/api/etranscript/mailToDoneStudent`,{'id':id, 'email':email,'user_id':user_id, 'date':date});
    }catch (error){
      this.handleError('mailToDoneStudent : ' + JSON.stringify(error));
    }
  }

  deleteApplicantFile(filename, user_id, transcriptId,firstname,lastname,email,name,app_id){
    try{
      //return  this.httpClient.delete(`${this.baseUrl}/api/etranscript/deleteTranscripts?data=`+id);
      return  this.httpClient.delete(`${this.baseUrl}/api/etranscript/deleteTranscripts?id=`+transcriptId+'&userId='+user_id+'&file_name='+filename+'&firstname='+firstname+'&lastname='+lastname+'&email='+email+'&name='+name+'&app_id='+app_id);
    }catch(error){
      this.handleError('deleteInstituteData: ' + JSON.stringify(error));
    }
  }

  paymentrequest(user_id, amount,address_id,delivery_time,type,service){
    try{
      return  this.httpClient.post(`${this.baseUrl}/api/payment/paymentrequest`,{"user_id":user_id, "amount":amount, "address_id":address_id, "delivery_time":delivery_time,"type":type,"service_type":service});
    }catch(error){
      this.handleError('paymentrequest: ' + JSON.stringify(error));
    }
  }

  downloadFiles(file_name,user_id):Observable<Blob>{
    try{
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.httpClient.get(`${this.baseUrl}/api/payment/download?file_name=`+file_name+'&user_id='+user_id, { headers: headers, responseType: 'blob'}).map(
        (res) => {
            return new Blob([res], { type: 'application/pdf' });
        });
    }catch(error) {
      this.handleError("unable to get Files : "+JSON.stringify(error));
    }
  }

  getApplicantFiles(user_id){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/etranscript/getApplicantFiles?user_id=`+user_id);
    }catch(error) {
        this.handleError("sendOtp : "+JSON.stringify(error));
    }
  }

  downloadTemplate():Observable<Blob>{
    try{
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.httpClient.get(`${this.baseUrl}/api/etranscript/downloadTemplate`, { headers: headers, responseType: 'blob'}).map(
        (res) => {
            return new Blob([res], { type: 'application/pdf' });
        });
    }catch(error) {
      this.handleError("unable to get Files : "+JSON.stringify(error));
    }
  }
  downloadManual():Observable<Blob>{
    try{
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.httpClient.get(`${this.baseUrl}/api/etranscript/downloadManual`, { headers: headers, responseType: 'blob'}).map(
        (res) => {
            return new Blob([res], { type: 'application/pdf' });
        });
    }catch(error) {
      this.handleError("unable to get Files : "+JSON.stringify(error));
    }
  }
  downloadTc():Observable<Blob>{
    try{
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.httpClient.get(`${this.baseUrl}/api/etranscript/downloadTc`, { headers: headers, responseType: 'blob'}).map(
        (res) => {
            return new Blob([res], { type: 'application/pdf' });
        });
    }catch(error) {
      this.handleError("unable to get Files : "+JSON.stringify(error));
    }
  }

  setEducationalValues(name){
    try{
        return  this.httpClient.post(`${this.baseUrl}/api/attestation/set_Educational_Values`,{data : name});
    }catch(error){
      this.handleError("setEducationalValues: "+JSON.stringify(error));
    }
  }

  getApplicantEducationalValues(user_id){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/attestation/getEducationalValues?user_id=`+user_id);
    }catch(error) {
        this.handleError("getApplicantEducationalValues : "+JSON.stringify(error));
    }
  }

  getEducation(edu_id,user_id){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/attestation/getEducation?user_id=`+user_id+`&edu_id=`+edu_id);
    }catch(error) {
        this.handleError("sendOtp : "+JSON.stringify(error));
    }
  }

  deleteEducation(id,firstname,lastname,email){
 try{
      return  this.httpClient.post(`${this.baseUrl}/api/attestation/deleteEducation`,{"data":id,"firstname":firstname,"lastname":lastname,"email":email});
    }catch(error){
      this.handleError('deleteInstituteData: ' + JSON.stringify(error));
    }
  }

  getEducation1(user_id){
    console.log('service',user_id);
    try{
      return this.httpClient.get(`${this.baseUrl}/api/attestation/getEducation1?user_id=`+user_id);
    }catch(error) {
        this.handleError("sendOtp : "+JSON.stringify(error));
    }
  }
  getCouses(){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/attestation/getCouses`);
    }catch(error) {
        this.handleError("getCouses : "+JSON.stringify(error));
    }
  }

  getCousesColleges(){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/attestation/getColleges`);
    }catch(error) {
        this.handleError("getCousesColleges : "+JSON.stringify(error));
    }
  }

  getColleges(){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/attestation/getColleges`);
    }catch(error) {
        this.handleError("getCousesColleges : "+JSON.stringify(error));
    }
  }

  getCourses(){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/attestation/getCourses`);
    }catch(error) {
        this.handleError("getCourses : "+JSON.stringify(error));
    }
  }

  async getAllEducationalData(userId){
    try{
      return await this.httpClient.get(`${this.baseUrl}/api/admin/adminDashboard/getAllEducationalData?userId=`+userId).toPromise();
    }catch(error) {
      this.handleError("Error in getAllEducationalData : "+error);
    }
  }

  async getApplicationLength(){
    try{
       return await this.httpClient.get(`${this.baseUrl}/api/dashboard/getApplicationLength`);
    }catch(error) {
      this.handleError("getApplicationLength : "+error);
    }
  }

  trackerChecktab(id){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/dashboard/trackerChecktab?id=`+id);
    }catch(error){
      this.handleError("trackerChecktab :"+error)
    }
  }

  trackerprofileStep(id){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/dashboard/trackerprofileStep?id=`+id);
    }catch(error){
      this.handleError("trackerprofileStep :"+error)
    }
  }

  get_applicant_data(user_id){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/etranscript/get_applicant_data?user_id=`+user_id);
    }catch(error) {
        this.handleError("get_applicant_data : "+JSON.stringify(error));
    }
  }

  regeneratePdf(appl_id,user_id,reg_reason,email_admin) {
    try{
      return this.httpClient.get(`${this.baseUrl}/api/admin/adminDashboard/regeneratePdf?user_id=${user_id}&appl_id=${appl_id}&reg_reason=${reg_reason}&email_admin=${email_admin}`);
    }catch(error) {
        this.handleError("regeneratePdf : "+JSON.stringify(error));
    }
  }

  courierSend(appl_id,user_id,email_admin) {
    try{
      return this.httpClient.get(`${this.baseUrl}/api/admin/adminDashboard/courierSend?user_id=${user_id}&appl_id=${appl_id}&email_admin=${email_admin}`);
    }catch(error) {
        this.handleError("courierSend : "+JSON.stringify(error));
    }
  }

  coursewisestats(){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/admin/adminDashboard/coursewisestats`);
    }catch(error) {
      this.handleError("coursewisestats : "+JSON.stringify(error));
    }
  }

  checkPinValues(data){
    try{
      return  this.httpClient.post(`${this.baseUrl}/api/checkPinValues`,{data : data});
    }catch(error){
      this.handleError("checkPinValues: "+JSON.stringify(error));
    }
  }

  verification(app_id,user_id,type,checked,email_admin){
    try{
      return this.httpClient.post(`${this.baseUrl}/api/admin/adminDashboard/verification`,{"user_id":user_id,"app_id":app_id,"type":type,"checked":checked,"email_admin":email_admin});;
        //return this.httpClient.get(requestUrl);
      }catch(error){
        this.handleError("verification : "+JSON.stringify(error));
      }
  }

  admin_pass_reset(user_mail){
    try{
      return this.httpClient.post(`${this.baseUrl}/api/admin/adminResetPassword`,{data: user_mail});
    }catch (error) {
      this.handleError("adminResetPassword: "+JSON.stringify(error));
    }
  }

  saveNotes(id,notes,email_admin){
    try{
      return this.httpClient.post(`${this.baseUrl}/api/admin/saveNotes`,{id : id, notes : notes,email_admin:email_admin});
    }catch(error) {
        this.handleError("saveNotes : "+JSON.stringify(error));
    }
  }

  lockUnlockEdu(app_id,lock,email_admin){
    try{
      return this.httpClient.post(`${this.baseUrl}/api/admin/adminDashboard/lockUnlockEdu`,{"app_id":app_id,"lock":lock,"email_admin":email_admin});
    }catch(error){
      this.handleError(" lockUnlockEdu : "+JSON.stringify(error))
    }
  }
  name_changes(fullname, userID){
    console.log(fullname);
    try {
      return this.httpClient.post(`${this.baseUrl}/api/admin/nameChange`,{
        data: userID,
        fname: fullname,
      });
    } catch (error) {
      this.handleError("nameChange: "+JSON.stringify(error));
    }
  }

  prnValues(data){
    try{
      return this.httpClient.post(`${this.baseUrl}/api/auth/checkPrn`,{data : data});
    }catch(error){
      this.handleError("prnValues: "+JSON.stringify(error));
    }
  }

  returnDuplicateCertificate(type,app_id , id,  reason){
    try{
      return this.httpClient.post(`${this.baseUrl}/api/attestation/returnDuplicateCertificate`,{type : type, app_id : app_id, reason : reason, user_id :id });
    }catch(error){
      this.handleError("returnDuplicateCertificate: "+JSON.stringify(error));
    }
  }

  getCheckTab(user_id,prn_data){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/etranscript/getCheckTab?user_id=`+user_id+`&prn_data=`+prn_data);
    }catch(error){
      this.handleError("getCheckTab :"+error)
    }
  }

  updateCollegeStatus(status, college_id, college_name){
    try{
      return this.httpClient.post(`${this.baseUrl}/api/admin/collegeManagement/updateCollegeStatus`,{"college_id":college_id, "college_status":status, "college_name":college_name })
     }catch(error) {
       this.handleError("updateCollegeStatus : "+JSON.stringify(error));
     }
  }

  printAddress(appl_id,user_id,section) {
    try{
      return this.httpClient.post(`${this.baseUrl}/api/signpdf/printAddress`,{"user_id":user_id, "appl_id": appl_id, "section":section});
    }catch(error) {
        this.handleError("printAddress : "+JSON.stringify(error));
    }
  }

  multipleTranformData(item:any,user_id):Observable<any>{
    try{
      return  this.httpClient.post(`${this.baseUrl}/api/etranscript/multipleTranformData`,{'item':item,'user_id':user_id});
    }catch (error){
      this.handleError('multipleTranformData : ' + JSON.stringify(error));
    }
  }

  getMultiTranFiles(user_id){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/etranscript/getMultiTranFiles?user_id=`+user_id);
    }catch(error) {
        this.handleError("sendOtp : "+JSON.stringify(error));
    }
  }



  getEducationCourseName(user_id){
    try{
      const requestUrl = `${this.baseUrl}/api/admin/adminDashboard/getEducationCourseName?user_id=`+user_id;
      return this.httpClient.get(requestUrl);
    }catch(error){
      this.handleError("getEducationCourseName : "+JSON.stringify(error));
    }
  }

  updateCourseName(program_id, user_id, course_name) {
    try{
      return this.httpClient.post(`${this.baseUrl}/api/admin/adminDashboard/updateCourseName`,{'user_id':user_id,'program_id':program_id,'course_name':course_name});
    }catch(error) {
        this.handleError("updateCourseName : "+JSON.stringify(error));
    }
  }

  getPatternData(college,course){
    try{
      const requestUrl = `${this.baseUrl}/api/attestation/getPatternData?college=`+college+`&course=`+course;
      return this.httpClient.get(requestUrl);
    }catch(error){
      this.handleError("getPatternData : "+JSON.stringify(error));
    }
  }

  updateDelivery(delivery_type, delivery_time, value, portal) {
    try{
      return this.httpClient.post(`${this.baseUrl}/api/attestation/updateDelivery`,{'delivery_type':delivery_type,'delivery_time':delivery_time,'value':value,'portal':portal});
    }catch(error) {
        this.handleError("updateDelivery : "+JSON.stringify(error));
    }
  }

  printApplication(user_id){
    try{
      return this.httpClient.get(`${this.baseUrl}/api/signpdf/printApplication?user_id=`+user_id)
    }catch(error){
      this.handleError("printApplication : "+JSON.stringify(error));
    }
  }

  checkDuplicate(name,user_id,college){console.log("check");
  try{
    return this.httpClient.post(`${this.baseUrl}/api/attestation/checkDuplicate`,{
      name : name,
      user_id : user_id,
      college : college
    })
  }catch(error){
    this.handleError("checkDuplicate: "+JSON.stringify(error))
  }
}

getFetchDoc(user_id){console.log("getfetchdata");
try{
  return this.httpClient.get(`${this.baseUrl}/api/etranscript/getFetchDoc?user_id=`+user_id)
}catch(error){
  this.handleError("getFetchDoc: "+JSON.stringify(error))
}
}

addAlternateAddress(address,user_id,id){
  try{
    return this.httpClient.post(`${this.baseUrl}/api/etranscript/addAlternateAddress`,{'address':address,'user_id':user_id,"address_id":id})
  }catch(error){
    this.handleError('addAlternateAddress: '+JSON.stringify(error))
  }
}

MergeDocuments(app_id,user_id){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/signpdf/mergeAllUserDocuments?app_id=`+app_id+'&user_id='+user_id)
  }catch(error){
    this.handleError('MergeDocuments: '+JSON.stringify(error))
  }
}

getFetchEducation(user_id){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/etranscript/getFetchEducation?&user_id=`+user_id)
  }catch(error){
    this.handleError('getFetchEducation: '+JSON.stringify(error))
  }
}

getAddress(user_id){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/etranscript/getAddress?&user_id=`+user_id)
  }catch(error){
    this.handleError('getAddress: '+JSON.stringify(error))
  }
}

getmultiPayment(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/etranscript/getmultiPayment`)
  }catch(error){
    this.handleError('getmultiPayment: '+JSON.stringify(error))
  }
}
getApplicationdata(){
  try{
  return this.httpClient.get(`${this.baseUrl}/api/etranscript/getApplicationdata`)
}catch(error){
  this.handleError('getApplicationdata: '+JSON.stringify(error))
}
}
alldetails(){
  try{
  return this.httpClient.get(`${this.baseUrl}/api/etranscript/alldetails`)
}catch(error){
  this.handleError('alldetails: '+JSON.stringify(error))
}
}
courierReturn(data,user_id){
  try{
  return this.httpClient.post(`${this.baseUrl}/api/etranscript/courierReturn`,{'data' : data,'user_id':user_id});
}catch(error){
  this.handleError('courierReturn: '+JSON.stringify(error))
}
}
courierdetail(){
  try{
  return this.httpClient.get(`${this.baseUrl}/api/etranscript/courierdetail`);
}catch(error){
  this.handleError('courierdetail: '+JSON.stringify(error))
}
}

getDuplicateApplied(){
  try{
    return this.httpClient.get(`${this.baseUrl}/api/etranscript/getDuplicateApplied`)
  }catch(error){
    this.handleError('getDuplicateApplied: '+JSON.stringify(error))
  }
}
duplicateApply(data){
  try{
    return this.httpClient.post(`${this.baseUrl}/api/etranscript/duplicateApply`,{data:data})
  }catch(error){
    this.handleError('duplicateApply: '+JSON.stringify(error))
  }
}
setResolve(id,email,value){console.log("id",id,email,value);

  try{
    return this.httpClient.post(`${this.baseUrl}/api/admin/setResolve`,{ "id" : id,"email" : email,"value":value})
  }catch(error){
    this.handleError('setResolve: '+JSON.stringify(error))
  }
}
getEnrollmentData(enrollment){
  return this.httpClient.post(`${this.baseUrl}/api/attestation/getEnrollmentData`,{"enrollment" :  enrollment})
}


AddCourseName(course_name,degree_type,duration,addEdit,id){
  try{
    return this.httpClient.post(`${this.baseUrl}/api/admin/collegeManagement/addcourse`,{"course_name":course_name,"degree_type":degree_type,"duration":duration,"addEdit":addEdit,'id':id})
   }catch(error) {
     this.handleError("addOrUpdateCollegeData : "+JSON.stringify(error));
   }
}

getAllEmailData(page,to_email,subject){
  // console.log(" riteteggdghhdjchhdh",to_email,subject);
  try{
    return this.httpClient.get(`${this.baseUrl}/api/admin/getAllEmailActivityTracker?page=`+page+`&to_email=`+to_email+`&subject=`+subject);
}catch(err){
  this.handleError("getAllEmailData :"+JSON.stringify(err));

  }
}

getVerifiedOtp(userId:number):any{
  try{
    return this.httpClient.get(`${this.baseUrl}/api/attestation/verifiedOtp?userId=${userId}`);
  }catch(error) {
      this.handleError("updateCourseName : "+JSON.stringify(error));
  }
}

postVerifiedOtp(userId:number,value:boolean) {
  try{
    return this.httpClient.post(`${this.baseUrl}/api/attestation/postVerifiedOtp`,{"userId":userId,"value":value});
  }catch(error) {
      this.handleError("updateCourseName : "+JSON.stringify(error));
  }
}

getnotes(){
  try{
    return  this.httpClient.get(`${this.baseUrl}/api/admin/adminDashboard/notes`);
  }catch (error){
    this.handleError('get notes Details : ' + JSON.stringify(error));
  }
}

incorrect_admin(app_id,user_id,reason,email_admin){
  try{
    return this.httpClient.post(`${this.baseUrl}/api/admin/adminDashboard/returntopending`,{"app_id":app_id,"user_id":user_id,"reason":reason,"email_admin":email_admin})
  }catch(error){
    this.handleError('returntopending: '+JSON.stringify(error))
  }
  }

  faq(id) {

    return this.httpClient.get(`${this.baseUrl}/api/help?id=${id}`)
  }
}
